import React, { useMemo, useState } from 'react'
import { Badge, IconButton, makeStyles, Tooltip } from '@material-ui/core'
import binIcon from 'assets/images/16px/bin@1x.svg'
import { Translate } from 'react-localize-redux'
import editIcon from 'assets/images/16px/edit@1x.svg'
import duplicateIcon from 'assets/images/16px/duplicate@1x.svg'
import useTeamFeature from 'hooks/useTeamFeature'
import LockIcon from '@material-ui/icons/Lock'
import PropTypes from 'prop-types'
import { TRAININGS_GAME } from 'constants/calender'
import TEAM_FEATURE_FLAGS from 'constants/teamFeatureFlags'

const useStyles = makeStyles((theme) => ({
  lockBadgeOnIconButton: {
    '& .MuiBadge-badge': {
      width: 12,
      height: 12,
      minWidth: 12,
      backgroundColor: theme.palette.background.paper,
    },
    '& .MuiBadge-anchorOriginTopRightCircular .MuiSvgIcon-root': {
      fontSize: 10,
    },
  },
}))

const Actions = ({ event, onOpen, onDuplicateBox, onDeleteEvent }) => {
  const classes = useStyles()

  const { enabled: hasCreateMatchEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.create_match_enabled
  )
  const { enabled: hasCreateGeneralEventEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.create_general_event_enabled
  )
  const { enabled: hasCreateTrainingEnabled } = useTeamFeature(
    TEAM_FEATURE_FLAGS.create_training_enabled
  )

  const [showActionButtons, setShowActionButtons] = useState(false)

  const getEventType = (relation) => {
    if (relation === 'match') return TRAININGS_GAME.game
    if (relation === 'training') return TRAININGS_GAME.training

    return TRAININGS_GAME.event
  }

  useMemo(() => {
    switch (event?.relation) {
      case 'match':
        setShowActionButtons(hasCreateMatchEnabled)
        break
      case 'training':
        setShowActionButtons(hasCreateTrainingEnabled)
        break
      case 'event':
        setShowActionButtons(hasCreateGeneralEventEnabled)
        break
      default:
        break
    }
  }, [event])

  return (
    <>
      <Tooltip
        title={<Translate id="button.duplicate" />}
        placement="top"
        arrow
      >
        <IconButton
          onClick={() => onDuplicateBox(event.id, event.relation, true)}
        >
          <Badge
            className={classes.lockBadgeOnIconButton}
            badgeContent={
              !showActionButtons ? (
                <LockIcon color="primary" fontSize="small" />
              ) : null
            }
            overlap="circular"
          >
            <img src={duplicateIcon} alt={duplicateIcon} />
          </Badge>
        </IconButton>
      </Tooltip>

      <Tooltip title={<Translate id="button.edit" />} placement="top" arrow>
        <IconButton
          onClick={() => onOpen(getEventType(event.relation), false, event)}
        >
          <Badge
            className={classes.lockBadgeOnIconButton}
            badgeContent={
              !showActionButtons ? (
                <LockIcon color="primary" fontSize="small" />
              ) : null
            }
            overlap="circular"
          >
            <img src={editIcon} alt={editIcon} />
          </Badge>
        </IconButton>
      </Tooltip>

      <Tooltip title={<Translate id="button.delete" />} placement="top" arrow>
        <IconButton onClick={() => onDeleteEvent(event.id, event.relation)}>
          <Badge
            className={classes.lockBadgeOnIconButton}
            badgeContent={
              !showActionButtons ? (
                <LockIcon color="primary" fontSize="small" />
              ) : null
            }
            overlap="circular"
          >
            <img src={binIcon} alt={binIcon} />
          </Badge>
        </IconButton>
      </Tooltip>
    </>
  )
}

Actions.propTypes = {
  onDeleteEvent: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  onDuplicateBox: PropTypes.func.isRequired,
  event: PropTypes.shape().isRequired,
}

export default Actions
